import { render, staticRenderFns } from "./Professionnalisation3.vue?vue&type=template&id=f9a46c1c"
import script from "./Professionnalisation3.vue?vue&type=script&lang=js"
export * from "./Professionnalisation3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports